import { useState } from 'react';

import failure from '@/assets/images/failure.svg';
import { getErrorMessage } from '@/utils/errors';
import {
  CodeBlock,
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Flex,
  Image,
  Link,
} from '@customerio/pluma-components/react';

interface ErrorPageProps {
  error?: unknown;
}

const ErrorPage = ({ error }: ErrorPageProps) => {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <EmptyState>
      <EmptyStateGraphic>
        <Image src={failure} width={80} height={80} alt="" role="presentation" />
      </EmptyStateGraphic>
      <EmptyStateTitle>Whoops!</EmptyStateTitle>
      <EmptyStateDescription>
        There was a problem loading this page. If this problem continues,{' '}
        <Link href="mailto:win@customer.io" isExternal={true} variant="secondary">
          please contact our support team
        </Link>
        .
      </EmptyStateDescription>
      {error != null ? (
        <EmptyStateActions>
          <Flex direction="column" alignItems="center" gap="200" w="full">
            <Link
              variant="secondary"
              icon={showDetails ? 'chevron-down' : 'chevron-right'}
              iconPosition="trailing"
              onClick={() => {
                setShowDetails((previous) => !previous);
              }}
            >
              {showDetails ? 'Hide error details' : 'Show error details'}
            </Link>
            {showDetails ? (
              <CodeBlock
                code={getErrorMessage(error)}
                language="plain"
                withCopyButton={true}
                withLineNumbers={false}
                style={{ maxWidth: '600px', width: '100%' }}
              />
            ) : null}
          </Flex>
        </EmptyStateActions>
      ) : null}
    </EmptyState>
  );
};

export default ErrorPage;
